import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, Sparkles, Package } from 'lucide-react';

const features = [
  {
    icon: Shield,
    title: '100% Authentic',
    description: 'All products are sourced from trusted mines and certified by gemology labs.',
  },
  {
    icon: Sparkles,
    title: 'Energized by Astrologers',
    description: 'Every item is energized with mantras by our certified astrologers.',
  },
  {
    icon: Award,
    title: 'Lab Certified',
    description: 'Products come with authenticity certificates from trusted labs.',
  },
  {
    icon: Package,
    title: 'Handcrafted',
    description: 'Meticulously crafted by experienced artisans with attention to detail.',
  },
];

export const WhyChooseUs = () => {
  return (
    <section className="py-16 lg:py-24" data-testid="why-choose-section">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Why Choose <span className="text-gold-gradient">Astro Vastu Remedies</span>?
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We are committed to providing authentic, energized spiritual products
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group text-center p-6 rounded-2xl bg-card border border-border hover:border-gold/50 transition-colors"
              data-testid={`feature-${index}`}
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gold/10 flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                <feature.icon className="w-8 h-8 text-gold" />
              </div>
              <h3 className="font-serif text-lg font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-muted-foreground text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
